import axios from 'axios'
import {clearCookies, setCookie} from '@/lib'
import { MessagePlugin } from 'tdesign-vue-next'
import $ from 'jquery'
const methods = {
  get (url) {
    return axios.get(url).then((resp) => {
      console.log(111, 'get then', resp)
    }).catch((resp) => {
      console.log(111, 'get catch', resp)
    })
  },
  post (url, params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url + '?api_key=70f71280d5d547b2a7bb370a529aeea1',
        type: 'POST',
        data: params && JSON.stringify(params) || undefined,
        xhrFields: {
          withCredentials: true // 这里设置了withCredentials
        },
        headers: {
          'Session-Target': window.localStorage.getItem('sessionTarget') || 1,
          'Content-Type': 'application/json'
        },
        dataType: 'json',
        success (resp) {
          let result = resp || {}
          if (result.code === 200) {
            resolve(result.data)
          } else if (result.code === 11003 || result.code === 406 || result.code === 11000) {
            clearCookies()
            window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(window.location.href)}`
          } else {
            MessagePlugin.warning(`${result.msg || '网络异常，请稍后重试'}`)
            reject(result)
          }
        },
        error (resp) {
          console.log(11, 'error', resp)
          alert(resp.message || resp)
          reject({
            code: resp.code,
            msg: resp.message
          })
        }
      })
      /*
      axios.post(url + '?api_key=70f71280d5d547b2a7bb370a529aeea1', params, {
        withCredentials: true,
        headers: {
          'Session-Target': window.localStorage.getItem('sessionTarget') || 1
        }
      }).then((resp) => {
        let result = resp.data || {}
        if (result.code === 200) {
          resolve(result.data)
        } else if (result.code === 11003 || result.code === 406 || result.code === 11000) {
          clearCookies()
          window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(window.location.href)}`
        } else {
          MessagePlugin.warning(`${result.msg || '网络异常，请稍后重试'}`)
          reject(result)
        }
      }).catch((resp) => {
        alert(resp.message || resp)
        reject({
          code: resp.code,
          msg: resp.message
        })
      })
      */
    })
  }
}

const Request = (reqArgs, params, params2) => {
  setCookie('XSRF-TOKEN', '', -1, 'vip.com')
  setCookie('XSRF-TOKEN', '', -1, 'school.vip.com')
  const req = {
    type: 'post'
  }
  if (Object.prototype.toString.call(reqArgs) === '[object String]') {
    req.url = reqArgs
  } else {
    Object.assign(req, reqArgs)
  }
  req.type = req.type || 'post'
  req.type = req.type.toLocaleLowerCase()
  let queryStr = []
  if (params && params2) {
    for (let key in params)  {
      queryStr.push(`${key}=${params[key]}`)
    }
    req.url = queryStr.length ? `${reqArgs.url}?${queryStr.join('&')}` : reqArgs.url
    params = params2
  }
  return methods[req.type](req.url, params)
}

export default Request
